
{
  "familyId": "SPR-KLANK-JAGER",
  "questions": [
    {
      "id": "SPR-KLANK-JAGER-001",
      "familyId": "SPR-KLANK-JAGER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_open_lange",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist?",
      "context": null,
      "options": ["voetbalschoenen", "voetbal schoenen", "voet balschoenen", "voet bal schoenen"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "syllableBlocks", "data": { "word": "voetbalschoenen", "syllables": ["voet", "bal", "schoe", "nen"], "types": ["closed", "closed", "open", "closed"], "label": "Lettergreepverdeling" }, "showWhen": "wrong" }, { "type": "rule", "data": { "title": "Samengestelde woorden", "content": "Samengestelde woorden schrijf je aan elkaar: voet + bal + schoenen = voetbalschoenen. Geen spaties tussen de delen!", "icon": "book" }, "showWhen": "wrong" }],
      "conceptId": "compound_word_joined",
      "variantIndex": 1,
      "feedback": { "explanationText": "Samengestelde woorden schrijf je aan elkaar zonder spaties. 'Voetbalschoenen' bestaat uit drie delen: voet + bal + schoenen. Deze schrijf je als één woord.", "distractorExplanations": { "0": "Correct! Samengestelde woorden schrijf je aan elkaar.", "1": "Fout: je schrijft geen spatie tussen 'voetbal' en 'schoenen'. Het is één woord.", "2": "Fout: je schrijft geen spatie tussen 'voet' en 'bal'. Alle delen schrijf je aan elkaar.", "3": "Fout: samengestelde woorden schrijf je helemaal aan elkaar, zonder spaties." } }
    }
  ]
}
